<template>
  <v-tooltip
    :open-delay="tooltipDelay"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        color="primary"
        small
        dark
        v-clipboard="() => valueToCopy"
        v-bind="attrs"
        v-on="on"
      >
        mdi-content-copy
      </v-icon>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
  import { mapGetters } from 'vuex'
  import i18n from '../i18n';

  export default {
    props: {
      tooltipText: {
        required: false,
        type: String,
        default: i18n.t('copy2Clipboard.defaultMessage')
      },
      valueToCopy: {
        required: true,
        type: String
      }
    },
    computed: {
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay'
      })
    }
  }
</script>

<style lang="scss" scoped>

</style>